import { render, staticRenderFns } from "./DashboardEventsTable.vue?vue&type=template&id=ba050164&"
import script from "./DashboardEventsTable.vue?vue&type=script&lang=js&"
export * from "./DashboardEventsTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEventsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports